export default __webpack_public_path__ + "79b6bf00c690cb00b69542db2e4f38bb.png";